import React from 'react';
import styled from 'styled-components';

export default function Div(props) {
  const Div = styled.div`
    margin: ${props.margin};
    width: ${props.width};
    height: ${props.height};
    max-width: ${props.maxWidth};
    max-height: ${props.maxHeight};
    min-height: ${props.minHeight};
    display: ${props.display};
    background-color: ${props.backgroundColor};
    color: ${props.color};
    padding: ${props.padding};
    top: ${props.top};
    bottom: ${props.bottom};
    left: ${props.left};
    right: ${props.right};
    transform: ${props.transform};
    position: ${props.position};
    border-radius: ${props.borderRadius};
    flex-direction: ${props.flexDirection};
    flex: ${props.flex};
    text-align: ${props.textAlign};
    overflow-y: ${props.overflowY};
    font-size: ${props.fontSize};
    white-space: ${props.whiteSpace};
    border: ${props.border};
  `;

  return <Div onClick={props.onClick}>{props.children}</Div>;
}
